import { useState } from "react";

export function useStringWithPlusMinus(sign: string) {
    const [state, setState] = useState("");

    const strippedState = state.replace(/[-+\s,]/g, "");

    const setUnstrippedState = (value: string) => {
        if (value === "") {
            setState("");
            return;
        }

        setState(`${sign} ${value}`);
    };

    return [state, setState, strippedState, setUnstrippedState] as const;
}
